<div class="modal-body">
    <div class="content">
        <h2 class="title">Corrections required</h2>
        <p class="description">
            Edit any errors you may have, and uncheck any entries you do not want to add into Certemy.
        </p>
        <cm-log-corrections-form
            [entries]="entries"
            [showErrors]="showErrors"
            class="corrections-form"
        ></cm-log-corrections-form>
        <p class="errors" *ngIf="showErrors">Please correct the fields highlighted.</p>
    </div>
</div>
<div class="modal-footer" *ngIf="!hideButtons">
    <button type="button" class="btn btn-default" (click)="goToPage.emit(PAGES.SUBMIT_CONTENT)">Back</button>
    <button type="button" class="btn btn-primary" (click)="submit()">Submit</button>
</div>
